<template>
  <div
    class="summary coupon"
    :class="{ 'pt-5': !currentBrand }"
    :style="{ position: processInProgress(process) ? 'relative' : '' }"
  >
    <loader v-show="processInProgress(process)" />
    <div class="overlay-coupon" v-show="processInProgress(process)"></div>
    <div v-if="cart_items_count">
      <h6>{{ _T('Apply coupon code to get discount') }}</h6>
      <form class="default-form" @submit.prevent>
        <div class="form-group">
          <input
            type="text"
            v-model="coupon"
            :placeholder="_T('Coupon Code')"
            @keydown="validateCouponText($event)"
            maxlength="16"
          />
          <button
            class="btn btn-solid"
            @click="removeCoupon"
            v-if="coupon_discount"
          >
            {{ _T('Remove') }}
          </button>
          <button class="btn btn-solid" @click="applyCoupon" v-else>
            {{ _T('Apply') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/Elements/Loader.vue'

export default {
  name: 'Coupon',
  components: {
    Loader,
  },
  computed: {
    ...mapGetters([
      '_T',
      'cart_items_count',
      'coupon_discount',
      'coupon_code',
      'currentBrand',
      'processInProgress',
      'is_customer_logged_in',
    ]),
    coupon: {
      get() {
        return this.coupon_code
      },
      set(code) {
        //code = code.replace(/\s/g, '').toUpperCase()
        return this.$store.commit('SET_COUPON_CODE', code)
      },
    },
  },
  data() {
    return {
      error: false,
      process: 'applyCoupon',
    }
  },
  watch: {
    coupon(val) {
      this.coupon = val.replace(/\W/g, '').toUpperCase()
    },
  },
  methods: {
    validateCouponText(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault()
      }
    },
    removeCoupon() {
      this.$store.dispatch('removeCoupon')
      this.$store.dispatch('showNotification', {
        text: this._T(`Discount removed from your cart`),
        status: 'success',
      })
      this.coupon = ''
    },
    applyCoupon() {
      this.error = false
      if (!this.coupon) {
        return false
      }
      if (this.processInProgress(this.process)) {
        return false
      }
      this.$store.dispatch('startProcess', {
        process: this.process,
        progress: false,
      })
      this.$store
        .dispatch('applyCoupon')
        .then(discount =>
          this.$store.dispatch('showNotification', {
            text: this._T(`Discount ${discount.name} applied on your cart`),
            status: 'success',
          })
        )
        .catch(error =>
          this.$store.dispatch('showNotification', {
            text: this._T(error),
            status: 'error',
          })
        )
        .finally(() => {
          this.$store.dispatch('stopProcess', this.process)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.coupon {
  border-top: 0.0625rem solid var(--color-light-border);
  padding-top: 1rem !important;
  padding-left: 1rem;
  padding-bottom: 0.5rem !important;

  .overlay-coupon {
    overflow: hidden;
    position: absolute;
    width: 92%;
    height: 82%;
    opacity: 0;
    background-color: #f8fbff;
    z-index: 99999999999;
    margin-left: -1rem;
  }

  .default-form .form-group {
    input,
    button {
      vertical-align: top;
      padding: 0;
      margin: 0;
      line-height: auto;
      padding: 0.4375rem 0.4125rem;
    }
    input {
      width: 60%;
    }
    button {
      margin-left: 1rem;
      width: 30%;
      text-align: center;
    }
  }
}
.body-rtl {
  .coupon {
    .default-form .form-group {
      button {
        margin-right: $px16;
        @media (max-width: 767px) {
          margin-right: unset;
        }
      }
    }
    text-align: right;
    margin-right: 2rem;
    @media (max-width: 575px) {
      margin-left: 2rem;
      margin-right: unset;
    }
    ul {
      padding-right: 0;
    }
  }
}

@media (max-width: 768px) {
  .coupon {
    width: 100% !important;
    padding: 0.9375rem 1.25rem;
    margin-top: 0.75rem;
    margin-bottom: 0;

    .default-form .form-group {
      input,
      button {
        vertical-align: top;
        padding: 0;
        margin: 0;
        line-height: auto;
        padding: 0.4375rem 0.4125rem;
        width: 100%;
      }

      button {
        margin-top: 1rem;
        text-align: center;
      }
    }
  }
}
</style>
